import FeatureLayer from '@arcgis/core/layers/FeatureLayer';
import SimpleRenderer from '@arcgis/core/renderers/SimpleRenderer';
import SimpleFillSymbol from '@arcgis/core/symbols/SimpleFillSymbol';

// Utils
import { getAdmin2LabelingInfo } from './mapLabeling.utils';

// Configs
import {
  ADMIN_2_REF_FEATURE_LAYER_ID,
  ADMIN_2_VECTOR_BOUNDARIES,
  ADMIN_2_REFERENCE_OUTLINE_COLOR,
} from '../configs/map.configs';

/**
 * Get the Admin 2 reference FeatureLayer
 * @param {string} countryName - Country name (e.g. 'Burkina Faso')
 * @returns {__esri.FeatureLayer} - Admin 2 reference FeatureLayer
 */
export function getAdmin2ReferenceFeatureLayer(countryName: string): __esri.FeatureLayer {
  return new FeatureLayer({
    id: ADMIN_2_REF_FEATURE_LAYER_ID,
    url: ADMIN_2_VECTOR_BOUNDARIES,
    definitionExpression: `ADM0_NAME = '${countryName}'`,
    outFields: ['ADM2_NAME', 'ADM1_NAME', 'ADM0_NAME'],
    labelingInfo: [getAdmin2LabelingInfo()], // Add the label class to the FeatureLayer
    renderer: new SimpleRenderer({
      label: 'Admin 2 Reference',
      symbol: new SimpleFillSymbol({
        color: 'transparent',
        outline: {
          // autocasts as new SimpleLineSymbol()
          width: 0.5,
          color: ADMIN_2_REFERENCE_OUTLINE_COLOR,
        },
      }),
    }),
  });
}
